import { Injectable, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

@Injectable()
export class AuthService {
  public isLoggedIn: boolean = false;
  public isLocated: boolean = false;
  public isConfirm: boolean = false;
  public redirectLink: string = '/';

  public token: string;

  changeLoginSubject = new BehaviorSubject(null);

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor() {
    this.token = localStorage.getItem('horseapp_token');
    this.isLoggedIn = localStorage.getItem('horseapp_token') !== null ? true : false;
    this.isLocated = this.readLocated();
    this.isConfirm = localStorage.getItem('isConfirm') !== null ? true : false;
  }

  // The region choice lasts for the browser session only, so every new visit
  // starts on /locate. A choice made on another EMR domain arrives here as
  // ?located=1, which is consumed once and then removed from the address bar.
  readLocated(): boolean {
    localStorage.removeItem('isLocated'); // clear the old permanent flag

    const arrivedWithChoice = /[?&]located=1(&|$)/.test(window.location.search);

    if (arrivedWithChoice) {
      sessionStorage.setItem('isLocated', 'true');
      // after the router has written its own url, so the param is not restored
      setTimeout(() => this.stripLocatedParam(), 0);
    }

    // the param alone counts, so a browser that refuses storage cannot loop
    return arrivedWithChoice || sessionStorage.getItem('isLocated') !== null;
  }

  setLocated(): void {
    sessionStorage.setItem('isLocated', 'true');
    this.isLocated = true;
  }

  stripLocatedParam(): void {
    const search = window.location.search
      .replace(/([?&])located=1(&|$)/, '$1')
      .replace(/[?&]$/, '');

    history.replaceState(null, '', window.location.pathname + search + window.location.hash);
  }

  login(token: string): void {
    localStorage.setItem('horseapp_token', token);
    this.isLoggedIn = true;
    this.token = token;
    this.sendEvent();
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem('horseapp_token');
    this.isLoggedIn = false;
    this.sendEvent();
  }

  sendEvent(){
    this.changeLoginSubject.next(this.isLoggedIn);
  }

  getRedirectLink():string{
    let link = this.redirectLink;
    this.redirectLink = '/';
    return link;
  }

  getToken(){
    return this.token;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/auth.service.ts